import { render, staticRenderFns } from "./ProjectStagesPage.vue?vue&type=template&id=014f9b02&scoped=true&lang=pug&"
import script from "./ProjectStagesPage.vue?vue&type=script&lang=js&"
export * from "./ProjectStagesPage.vue?vue&type=script&lang=js&"
import style0 from "./ProjectStagesPage.vue?vue&type=style&index=0&id=014f9b02&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014f9b02",
  null
  
)

export default component.exports